module.exports = __webpack_public_path__ + "img/security.a48f9bea.jpg";